<template>
  <div>
    <content-card v-if="screen == 'inputNumber'">
      <template v-slot:header
        ><div class="subtitle">{{ t("send_report.whatsapp.input") }}</div>
      </template>
      <template v-slot:description>
        <div class="d-flex justify-content-center flex-column align-items-center g-24">
          <vue-tel-input
            v-model="phoneNumberInput"
            mode="international"
            :dropdownOptions="{
              showFlags: false,
              showDialCodeInSelection: true,
              showDialCodeInList: true,
              showSearchBox: true,
              searchBoxPlaceholder: ' ',
            }"
            :inputOptions="{
              id: 'phone-number-input',
              styleClasses: ['phone-number-input'],
              placeholder: t('send_report.whatsapp.placeholder'),
            }"
            :defaultCountry="defaultCountry"
            styleClasses="phone-number-input-container"
            :validCharactersOnly="true"
            :autoFormat="false"
            @on-input="onInput"
            @country-changed="onCountryChanged"
          >
            <template v-slot:arrow-icon="{ open }">
              <img src="../assets/dropdown-close.svg" class="dropdown-open" alt="" v-if="open" />
              <img src="../assets/dropdown-close.svg" alt="" v-else />
            </template>
          </vue-tel-input>
          <div class="button-container g-24">
            <button type="button" class="continue-button" :disabled="disabled" @click="screen = 'confirmNumber'">
              {{ t("button.send") }}
            </button>
            <button class="continue-button-clear fwd-orange" @click="$emit('back')">{{ t("button.back") }}</button>
          </div>
        </div>
      </template>
    </content-card>
    <content-card v-else-if="screen == 'confirmNumber'">
      <template #header>
        <div class="subtitle">{{ t("button.confirm") }}</div>
      </template>
      <template #description>
        <div class="d-flex justify-content-center flex-column align-items-center g-24">
          <div class="text">
            <div>{{ t("send_report.whatsapp.check") }}</div>
            <div>{{ phoneNumber }}</div>
          </div>

          <div class="button-container g-24">
            <button type="button" class="continue-button" :disabled="loadingSending" @click="sendReport">
              <div v-if="!loadingSending">{{ t("button.send") }}</div>
              <div v-else class="d-flex justify-content-around">
                <img src="../assets/spinner.svg" alt="" class="spinner" />
                {{ t("send_report.sending") }}
              </div>
            </button>
            <button class="continue-button-clear fwd-orange" :disabled="loadingSending" @click="screen = 'inputNumber'">
              {{ t("button.back") }}
            </button>
          </div>
        </div>
      </template>
    </content-card>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { locale, t } = useI18n();
    return {
      locale,
      t,
    };
  },
  emits: ["back", "sendReport"],
  components: { VueTelInput },
  props: {
    loadingSending: Boolean,
  },
  data() {
    return {
      disabled: true,
      phoneNumberInput: null,
      phoneNumber: null,
      page: "infoInput",
      screen: "inputNumber",
      phoneObject: {
        formatted: "",
        valid: false,
        country: undefined,
      },
      defaultCountry: "HK",
    };
  },
  methods: {
    inputPhoneNumber(value) {
      this.phoneNumber += value;
      this.checkDisabled();
    },
    deletePhoneNumber() {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
      this.checkDisabled();
    },
    checkDisabled() {
      this.disabled = this.phoneNumber.length == 0;
    },
    updatePhoneNumber(value) {
      this.phoneNumber = value;
      this.checkDisabled();
    },
    sendReport() {
      this.$emit("sendReport", this.phoneNumber);
      this.defaultCountry = "HK";
    },
    onInput(formattedNumber, phoneObject) {
      if (!phoneObject.valid) {
        this.disabled = true;
      }
      if (phoneObject.valid) {
        this.disabled = false;
        this.phoneNumber = phoneObject.formatted;
      }
    },
    onCountryChanged(countryObject) {
      this.defaultCountry = countryObject.iso2;
    },
  },
};
</script>

<style scoped>
.input {
  width: 329px !important;
}
.button-container {
  display: flex;
  flex-direction: column;
}
.number-container {
  display: grid;
  grid-template-columns: auto auto auto;
  width: 329px;
  padding: 10px 0;
}
.number-container > button {
  padding: 10px;
  font-size: 30px;
  text-align: center;
  background-color: transparent;
  border: none;
}
.text {
  text-align: center;
  font-size: 25px;
  font-weight: 450;
}
.phone-number-input-container {
  display: flex;
  gap: 24px;
  border: none;
  outline: none;
  width: 100%;
}
.phone-number-input-container:focus-within {
  box-shadow: none;
}
.dropdown-open {
  transform: rotate(180deg);
}

@media (max-width: 767px) {
  .phone-number-input-container {
    gap: 10px;
  }
  .text {
    font-size: 14px;
  }
  .vti__dropdown-item {
    font-size: 14px;
  }
}
</style>
<style>
.phone-number-input {
  border: 1px solid #dbdfe1;
  border-radius: 4px;
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
  font-size: 25px;
  font-weight: 500;
  padding: 7px;
  flex-grow: 1;
}
.vti__dropdown {
  border: 1px solid #dbdfe1;
  border-radius: 4px;
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
  font-size: 25px;
  font-weight: 500;
  padding: 7px;
  min-width: 100px;
  align-items: center;
}
.vti__selection .vti__country-code {
  color: #183028 !important;
}
.vti__selection {
  display: flex;
  gap: 10px;
}
.vti__dropdown-item,
.vti__search_box {
  font-size: 20px;
}
.vti__search_box_container {
  height: 70px;
  padding: 10px;
}
.vti__search_box {
  height: 100%;
  width: 100%;
  margin: 0;
}
@media (max-width: 767px) {
  .phone-number-input-container {
    gap: 5px;
  }
  .phone-number-input {
    font-size: 14px;
  }
  .vti__dropdown {
    font-size: 14px;
    min-width: 65px;
  }
  .vti__selection {
    gap: 5px;
  }
  .vti__dropdown-item, .vti__search_box {
    font-size: 10px;
  }
  .vti__dropdown-list {
    max-width: 350%;
  }
  .vti__search_box_container {
    height: 40px;
    padding: 5px;
  }
  .vti__search_box {
    height: 100%;
    width: 100%;
    margin: 0;
  }
}
</style>
